export default __webpack_public_path__ + "static/connectFeaturedImage-ba573f1c2d7785041da87bdcfe128c4d.png";